/**
 * Utility function to get the correct image URL
 * Handles both external URLs (https://...) and local URLs (/api/uploads/...)
 */
export const getImageUrl = (url) => {
  if (!url) return null;
  // If it's already an absolute URL, return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // Otherwise, prepend the backend URL
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
};

/**
 * Get a placeholder avatar URL based on initials
 */
export const getPlaceholderAvatar = (name) => {
  const initial = name?.[0]?.toUpperCase() || '?';
  return `data:image/svg+xml,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <rect fill="#1a1a1a" width="100" height="100"/>
      <text x="50" y="50" font-family="Georgia, serif" font-size="40" fill="#d4af37" text-anchor="middle" dominant-baseline="central">${initial}</text>
    </svg>
  `)}`;
};

export default getImageUrl;
